import { FinancialWorkspaceValueObjectsFinanceTypeEnum } from 'generated/resources/graphql'

export interface SourcesVisibility {
  canSeeAgreements: boolean
  canSeeEmployeeExpenses: boolean
  canSeeLaborCosts: boolean
  canSeeCompensations: boolean
}

export const getFinanceTypes = (visibility: SourcesVisibility) => {
  const financeTypes: FinancialWorkspaceValueObjectsFinanceTypeEnum[] = []

  if (visibility.canSeeAgreements) {
    financeTypes.push('agreement')
  }

  if (visibility.canSeeEmployeeExpenses) {
    financeTypes.push('expense')
  }

  if (visibility.canSeeLaborCosts) {
    const type = visibility.canSeeCompensations ? 'compensations' : 'payroll'
    financeTypes.push(type)
  }

  return financeTypes
}
